import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StatCollaborateurService {

  private apiUrl = `${environment.baseUrlApi}/stats`;

  constructor(private http: HttpClient) {}

  /**
   * GET /api/stats/collaborateur/{id}
   * Stats globales d'un collaborateur parent
   */
  getStatsByCollaborateur(collaborateurId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/collaborateur/${collaborateurId}`);
  }

  /**
   * GET /api/stats/collaborateur/{id}/sous/{sous_id}
   * Stats filtrées par sous-collaborateur
   */
  getStatsBySousCollaborateur(collaborateurId: number, sousId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/collaborateur/${collaborateurId}/sous/${sousId}`);
  }
}